// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Heading-I {
    margin-top: 15px;
    color: white;
    font-size: 12px;
    margin-left: 20px;
    margin-bottom: 5px;
}
.tab{
    width: 1100px;
}
.spinner {
    border: 8px solid rgba(255, 255, 255, 0.3); /* Light grey */
    border-top: 8px solid white; /* White */
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1.5s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
.loader-text {
    color: #AD8BFF;
    font-size: 12px;
    font-weight: 450;
}

.incident-loader {
    padding-top: 200px;
    padding-left: 150px;

}

.process-text {
    color: #AD8BFF;
    font-size: 12px;
    font-weight: 450;
}

.process-loader {
    padding-top: 40px;
    padding-bottom: 46px;
    padding-left: 40px;

}

.App {
    margin-left: 30px;
    /* width:1600px; */
}

.incident {
    background-color: rgba(255, 255, 255, 0.05);
    border-radius: 8px;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(116, 123, 169, 1);
    padding: 2px;
    margin-top: 13px;
    margin-left: 10px;
    border-bottom-style: solid;
    border-radius: 12px;
    width: 1100px;
    height: 526px;
}

.cd-nav {
    margin-right: 15px;
    padding-bottom: 4px;
    text-decoration: none;
    font-size: 15px;
    margin-left: 20px;
    color: #738395;
    border-bottom-style: solid;
    /* border-image: linear-gradient(to right, blueviolet 50%, transparent 50%) 100% 1; */
    /* border-color: #202342; */
    border-width: 2px;
    /* border-bottom-style: solid; */
}

.line {
    width: 95%;
    color: aliceblue;
    size: 10px;
    margin-left: 20px;
}

.resultNav {
    text-decoration: none;
}

.cd-nav:hover {
    color: blueviolet;
}

.planned-workorder {
    margin-left: 23px;
    margin-top: 15px;
    color: white;
    display: flex;

}

.workorder {
    border-right: 1px solid rgba(128, 128, 128, 0.447);
    width: 455px;
    font-size: 13px;
    font-weight: 500;
    height: 110px;
}

.workordericon {
    margin-left: 60px;
    padding-right: 30px;
    width: 90px;
    height: 90px;
    margin-top: -10px;
}

.generatesection {

    margin-left: 60px;
    padding: 20px;
    border: 1px solid rgba(128, 128, 128, 0.447);
    border-radius: 12px;
    height: 110px;
    /* margin-right: 20px */
}

.generatebutton {
    border-radius: 8px;
    margin-left: 240px;
    background-color: rgba(116, 123, 169, 1);
    color: white;
    text-align: center;
    text-decoration: none;
    font-size: 15px;
    width: 170px;
    border: 2px solid rgba(116, 123, 169, 1);
    float: right;
    margin-top: -50px;
}

.processebutton-incidents {
    border-radius: 8px;
    margin-right: 80px;
    background-color: rgba(107, 92, 209, 1);
    color: white;
    text-align: center;
    text-decoration: none;
    font-size: 15px;
    width: 170px;
    /* border-style: solid; */
    border: 0px solid rgba(107, 92, 209, 1);
    float: right;
    margin-top: 60px
}

.generatetext {
    margin-top: 10px;
    font-size: 13px;
    font-weight: 500;
}

.generatetextbelow {
    margin-top: -19px;
    font-size: 13px;
    font-weight: 500;
}

.workorder-history-title {
    font-size: 13px;
    color: white;
    margin-left: 20px;
    font-weight: 500;
}
.workorder-planned-title {
    font-size: 13px;
    color: white;
    margin-left: 20px;
    font-weight: 500;
    margin-top: 7px;
}
/* .workorder-planned {
    height: 100px;
    width: 1060px;
    margin-left: 20px;
    margin-right: 10px;
    border: 1px solid #8d97dac5;
    border-radius: 5px;
    overflow: hidden;
} */

.workorder-hide-scroll {
    overflow: auto;
    /* width: 100%; */
    padding-right: 17px;
    box-sizing: content-box;
    height: fit-content;
    width: 1050px;
    margin-left: 20px;
    margin-right: 10px;
    border: 1px solid #8d97dac5;
    border-radius: 5px;
}

/* tbody::-webkit-scrollbar {
    width: 1em;
  } */

/* tbody::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }
    */
/* tbody::-webkit-scrollbar-thumb {
    background-color: darkgrey;
    outline: 1px solid slategrey;
  } */
/* Track */


/* Handle on hover */
/* ::-webkit-scrollbar-thumb:hover {
    background: #b30000;
} */

/* .workorder-history {
    overflow: hidden;
    height: 200px;
    width: 1060px;
    margin-left: 20px;
    margin-right: 10px;
    border: 1px solid #8d97dac5;
    border-radius: 5px;
} */

.workorder-history-table {
    overflow: auto;
    /* height: 100%;
    width: 100%; */
    margin-left: 15px;
    margin-right: 10px;
    height: 300px;
    width: 1050px;
    border: 1px solid #8d97dac5;
    border-radius: 5px;
    padding-right: 17px;
    /* padding-bottom: 17px; */
    box-sizing: content-box
}

.planned-table {
    border: 1px solid #8d97dac5;
    border-spacing: 100px;
    table-layout: fixed;
    /* width: 180px; */
}

.planned-table th {
    border: 1px solid #8d97dac5;
    padding: 5px;
    background-color: rgba(116, 123, 169, 1);
    color: white;
    font-size: 13px;
    font-weight: normal;
    text-align: center;
    position: sticky;
    top: 0; 
    /* width: 1000px; */
    /* white-space: nowrap; */
}

.planned-table td {
    border: 1px solid #8d97da76;
    padding: 1px;
    color: white;
    font-size: 12px;
    text-align: center;
    /* white-space: nowrap */
    /* object-fit: cover; */
}

/* .tbody{
    z-index: -9;
    width: 500%;
}
.thead{
    z-index: 100;
    
} */

.info-icon {
    margin-right: 20px;
    /* width: 15%; */
}

.gts {
    width: 98%;
    /* height: 50%; */
    background-color: #8d97dac5;
    color: white;
    border-radius: 5px;
    margin-left: 10px;
    /* display: inline-block; */
    margin-top: 6px;

}

.generateTitle {
    padding-top: 8px;
    padding-bottom: 8px;
    font-size: 14px;
    font-family: Graphik;
    text-align: center;
}

.closeicon {
    width: 18px;
    height: 18px;
    float: right;
    margin-top: 2px;
    margin-right: 15px;
}

.generate-data {
    color: white;
    padding: 2px;
    margin-top: 6px;
    margin-left: 10px;
    display: flex;
    flex-direction: row;
}

.generatecol-one {
    padding-right: 10px;
}

.container-row {
    display: flex;
    flex-direction: row;
    font-size: 12px;
    font-family: Graphik;
    padding-top: 10px;
}

.container-label {
    margin-left: 5px;
}

.container-data {
    background-color: #25304C;
    width: 200px;
    height: 30px;
    border-style: solid;
    border-width: 1px;
    border-radius: 5px;
    border-color: #8d97dac5;
    text-align: left;
    padding: 5px;
    color: white
}

.generate-header {
    color: white;
    padding-top: 9px;
    padding-bottom: 9px;
    font-size: 13px;
    font-family: Graphik;
    font-weight: 500;
}

.loading {
    color: white;
}

.loadingstyle {
    color: white;
    font-size: medium;
    width: 85vw;
    height: 70vh;
    display: flex;
    align-items: center;
    justify-content: center;
}

.insights {
    overflow: hidden;
    height: 550px;
    color: white;
    margin-top: 15px;
    margin-left: 10px;
    width: 1100px;
}

.hidescroll {
    /* height: 500px; */
    /* overflow-y: auto; */
    width: 1150px;
    height: 100%;
    overflow-y: auto;
    padding-right: 17px;
    /* Increase/decrease this value for cross-browser compatibility */
    box-sizing: content-box
}

.flexrow {
    /* margin-left: 23px; */
    margin-top: 5px;
    color: white;
    display: flex;
    background-color: rgba(255, 255, 255, 0.05);
    width: 1100px;
    padding: 15px;
    border-radius: 8px;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(116, 123, 169, 1);
    height: 460px;
}

.flexrow1 {
    /* margin-left: 23px; */
    margin-top: 5px;
    color: white;
    display: flex;
    background-color: rgba(255, 255, 255, 0.05);
    width: 1100px;
    padding: 15px;
    border-radius: 8px;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(116, 123, 169, 1);
    height: 320px;
}

.flexrow3 {
    margin-left: 2px;
    color: white;
    display: flex;
    /* background-color: rgba(255, 255, 255, 0.05); */
    padding: 15px;
    /* border-radius: 8px; */
    border-width: 1px;
    border-color: rgba(116, 123, 169, 1);
    /* height: 320px; */
    background-color: rgba(37, 42, 74, 1);
    border-width: 1px;
    border-bottom-style: solid;
    /* border-color: rgba(65, 67, 82, 1); */
    border-radius: 5px;
    height: 30px;
    color: white;
    width: 1095px;
    padding-top: 2px;
}

.chart {
    margin-bottom: 15px;
}
.sop-box{
    border-radius: 8px;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(116, 123, 169, 1);
    background-color: rgba(255, 255, 255, 0.05);
    width: 1100px;

}

/* .chartborder{
    color: rgba(65, 67, 82, 1);
} */
.chartborderright {
    /* margin-left: 13px; */
    border-color: rgba(65, 67, 82, 1);
    border-left-style: solid;
    border-width: 1px;
    padding-left: 30px;
}
.pdf-cd-box-rt{
    margin-bottom: 15px;
    margin-left: 5px;
    display: flex;

}
.pdf-text{
    margin-left: 30px;
    font-size: 11px;
    font-weight: 300;
    font-family: Graphik;
    color: white;
    width:250px;
    height: 60px;
    padding: 10px;
    text-align: left;
}
.pdf-cd-box{
    margin-bottom: 15px;
    margin-left: 5px;
    display: flex;
}
.heading-chart {
    font-size: 14px;
    font-weight: 500;
    font-family: Graphik;
    color: white;
    margin-left: 20px;
}

.heading-analysis {
    font-size: 14px;
    font-weight: 500;
    font-family: Graphik;
    color: white;
    margin-left: 10px;
}


.pdf-heading {
    font-size: 14px;
    font-weight: 500;
    font-family: Graphik;
    color: white;
    margin-left: 10px;
    margin-top: 10px;
}

.chart-box {
    margin-left: -10px;
}

.points {
    font-size: 12px;
    font-weight: 350;
    font-family: Graphik;
    color: rgb(199, 239, 246);
}

/* ul{ list-style: none;list-style-position: outside;
 } */
/* ul li {
    margin-bottom: -10px;
    color: aliceblue;
} */

/* ul li:before{ content:"•"; font-size:10pt;}

li:before{ margin-right: 10px;} */


.xAxis .recharts-layer.recharts-cartesian-axis-tick text {
    transform: translate(0, 2px);
    font-family: Roboto, sans-serif;
}

.yAxis .recharts-layer.recharts-cartesian-axis-tick text {
    transform: translate(-5px, 0);
}

.flexborder {
    background-color: rgba(37, 42, 74, 1);
    border-width: 1px;
    border-style: solid;
    border-color: rgba(65, 67, 82, 1);
    border-radius: 5px;
    height: 30px;
    color: white;
    display: flex;
    width: 1100px;
    padding-top: 2px;
}

.heading-topic {
    font-size: 14px;
    font-weight: 500;
    font-family: Graphik;
    color: white;
    margin-left: 10px;
    padding: 2px
}

.chart-box-below {
    width: 500px;
}

.custom-legend {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}

.legend-item {
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 10px;
}

.custom-legends {
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-76%) translateY(-30%);
}
.custom-legends-shape {
    margin-right: 20px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-40%) translateY(120%);
}


.legend-items {
    white-space: nowrap; 
    display: flex;
    align-items: center;
    /* margin-right: 10px; */
    margin-left: 10px;
}
.custom-legends-shape2 {
    margin-right: 10px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-42%) translateY(215%);
}


.legend-items2 {
    white-space: nowrap; 
    display: flex;
    align-items: center;
    /* margin-right: 10px; */
    margin-left: 10px;
}

.shape {
    width: 8px;
    height: 8px;
    margin-right: 5px;
}

.shape-circle {
    background-color: aliceblue;
    border-radius: 50%;
}

.shape-square {
    background-color: aliceblue;
}

.shape-triangle {
    border-left: 5px solid transparent;
    border-right:5px solid transparent;
    border-bottom: 10px solid aliceblue;
}

.shape-cross {
    background: aliceblue;
      height: 10px;
      position: relative;
      width: 2px;
      right:4px;
}
.shape-cross:after {
    background: aliceblue;
    content: "";
    height: 2px;
    left: -4px;
    position: absolute;
    top: 4px;
    width: 10px;

}
.shape-diamond {
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-bottom: 7px solid aliceblue;
    position: relative;
    top: -5px;
  }
.shape-diamond:after {
    content: '';
    position: absolute;
    left: -4.2px;
    top: 6px;
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-top: 7px solid aliceblue;
  }

.chatboticon {
    float: right;
    cursor: pointer;
}

/* .infoicon{
    margin-left: 560px;
    width: 30px;
} */

.top-sum {
    padding-right: 5px;
}

.tab {
    margin-right: 10px;
}

.pdf-cd{
    width:50px;
    height:70px;
    margin-left: 10px;
}
.pdf-contanier{
    margin: 15px;
    padding: 5px;
    background-color: rgba(255, 255, 255, 0.05);
    width: 1100px;
    border-radius: 8px;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(116, 123, 169, 1);
    height: 460px;
}

.close-pdf{
    height: 30px;
    margin-top: 10px;
    margin-right: 5px;
    cursor: pointer;
}

.q-model{
    background-color: rgba(30, 32, 61, 1);
    border-radius: 10px;
    border: 1px solid rgba(107, 92, 209, 1);
    height:400px;
    width: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    z-index: 1000;
    padding-top: 10px;
    top: 0;
    left: 0;
    width:100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }`, "",{"version":3,"sources":["webpack://./src/detectionTabs.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;AACA;IACI,0CAA0C,EAAE,eAAe;IAC3D,2BAA2B,EAAE,UAAU;IACvC,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,oCAAoC;EACtC;;EAEA;IACE,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;EACpC;;AAEF;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;;AAEvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;;AAEtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,2CAA2C;IAC3C,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,oCAAoC;IACpC,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;IAC1B,mBAAmB;IACnB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,0BAA0B;IAC1B,qFAAqF;IACrF,2BAA2B;IAC3B,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,aAAa;;AAEjB;;AAEA;IACI,kDAAkD;IAClD,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;;IAEI,iBAAiB;IACjB,aAAa;IACb,4CAA4C;IAC5C,mBAAmB;IACnB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,wCAAwC;IACxC,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,wCAAwC;IACxC,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,uCAAuC;IACvC,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,uCAAuC;IACvC,YAAY;IACZ;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;AACA;;;;;;;;GAQG;;AAEH;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;;KAEK;;AAEL;;;KAGK;AACL;;;KAGK;AACL,UAAU;;;AAGV,oBAAoB;AACpB;;GAEG;;AAEH;;;;;;;;GAQG;;AAEH;IACI,cAAc;IACd;kBACc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,2BAA2B;IAC3B,kBAAkB;IAClB,mBAAmB;IACnB,0BAA0B;IAC1B;AACJ;;AAEA;IACI,2BAA2B;IAC3B,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,YAAY;IACZ,wCAAwC;IACxC,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,MAAM;IACN,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,wBAAwB;IACxB,uBAAuB;AAC3B;;AAEA;;;;;;;GAOG;;AAEH;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,2BAA2B;IAC3B,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,2BAA2B;IAC3B,eAAe;;AAEnB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ;AACJ;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,iEAAiE;IACjE;AACJ;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,2CAA2C;IAC3C,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,oCAAoC;IACpC,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,2CAA2C;IAC3C,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,oCAAoC;IACpC,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,iDAAiD;IACjD,aAAa;IACb,wBAAwB;IACxB,iBAAiB;IACjB,oCAAoC;IACpC,mBAAmB;IACnB,qCAAqC;IACrC,iBAAiB;IACjB,0BAA0B;IAC1B,uCAAuC;IACvC,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,oCAAoC;IACpC,2CAA2C;IAC3C,aAAa;;AAEjB;;AAEA;;GAEG;AACH;IACI,uBAAuB;IACvB,iCAAiC;IACjC,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;;AAEjB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;IACZ,iBAAiB;AACrB;;;AAGA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI;AACJ;;;GAGG;;AAEH;;iCAEiC;;;AAGjC;IACI,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qCAAqC;IACrC,iBAAiB;IACjB,mBAAmB;IACnB,iCAAiC;IACjC,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;IACZ,iBAAiB;IACjB;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,4CAA4C;AAChD;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,4CAA4C;AAChD;;;AAGA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,4CAA4C;AAChD;;;AAGA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kCAAkC;IAClC,kCAAkC;IAClC,mCAAmC;AACvC;;AAEA;IACI,qBAAqB;MACnB,YAAY;MACZ,kBAAkB;MAClB,UAAU;MACV,SAAS;AACf;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,WAAW;;AAEf;AACA;IACI,QAAQ;IACR,SAAS;IACT,6BAA6B;IAC7B,kCAAkC;IAClC,kBAAkB;IAClB,SAAS;EACX;AACF;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,QAAQ;IACR,SAAS;IACT,6BAA6B;IAC7B,+BAA+B;EACjC;;AAEF;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;;;GAGG;;AAEH;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,2CAA2C;IAC3C,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,oCAAoC;IACpC,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,uCAAuC;IACvC,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,MAAM;IACN,OAAO;IACP,UAAU;IACV,YAAY;IACZ,oCAAoC;EACtC","sourcesContent":[".Heading-I {\n    margin-top: 15px;\n    color: white;\n    font-size: 12px;\n    margin-left: 20px;\n    margin-bottom: 5px;\n}\n.tab{\n    width: 1100px;\n}\n.spinner {\n    border: 8px solid rgba(255, 255, 255, 0.3); /* Light grey */\n    border-top: 8px solid white; /* White */\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    animation: spin 1.5s linear infinite;\n  }\n  \n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n  \n.loader-text {\n    color: #AD8BFF;\n    font-size: 12px;\n    font-weight: 450;\n}\n\n.incident-loader {\n    padding-top: 200px;\n    padding-left: 150px;\n\n}\n\n.process-text {\n    color: #AD8BFF;\n    font-size: 12px;\n    font-weight: 450;\n}\n\n.process-loader {\n    padding-top: 40px;\n    padding-bottom: 46px;\n    padding-left: 40px;\n\n}\n\n.App {\n    margin-left: 30px;\n    /* width:1600px; */\n}\n\n.incident {\n    background-color: rgba(255, 255, 255, 0.05);\n    border-radius: 8px;\n    border-width: 1px;\n    border-style: solid;\n    border-color: rgba(116, 123, 169, 1);\n    padding: 2px;\n    margin-top: 13px;\n    margin-left: 10px;\n    border-bottom-style: solid;\n    border-radius: 12px;\n    width: 1100px;\n    height: 526px;\n}\n\n.cd-nav {\n    margin-right: 15px;\n    padding-bottom: 4px;\n    text-decoration: none;\n    font-size: 15px;\n    margin-left: 20px;\n    color: #738395;\n    border-bottom-style: solid;\n    /* border-image: linear-gradient(to right, blueviolet 50%, transparent 50%) 100% 1; */\n    /* border-color: #202342; */\n    border-width: 2px;\n    /* border-bottom-style: solid; */\n}\n\n.line {\n    width: 95%;\n    color: aliceblue;\n    size: 10px;\n    margin-left: 20px;\n}\n\n.resultNav {\n    text-decoration: none;\n}\n\n.cd-nav:hover {\n    color: blueviolet;\n}\n\n.planned-workorder {\n    margin-left: 23px;\n    margin-top: 15px;\n    color: white;\n    display: flex;\n\n}\n\n.workorder {\n    border-right: 1px solid rgba(128, 128, 128, 0.447);\n    width: 455px;\n    font-size: 13px;\n    font-weight: 500;\n    height: 110px;\n}\n\n.workordericon {\n    margin-left: 60px;\n    padding-right: 30px;\n    width: 90px;\n    height: 90px;\n    margin-top: -10px;\n}\n\n.generatesection {\n\n    margin-left: 60px;\n    padding: 20px;\n    border: 1px solid rgba(128, 128, 128, 0.447);\n    border-radius: 12px;\n    height: 110px;\n    /* margin-right: 20px */\n}\n\n.generatebutton {\n    border-radius: 8px;\n    margin-left: 240px;\n    background-color: rgba(116, 123, 169, 1);\n    color: white;\n    text-align: center;\n    text-decoration: none;\n    font-size: 15px;\n    width: 170px;\n    border: 2px solid rgba(116, 123, 169, 1);\n    float: right;\n    margin-top: -50px;\n}\n\n.processebutton-incidents {\n    border-radius: 8px;\n    margin-right: 80px;\n    background-color: rgba(107, 92, 209, 1);\n    color: white;\n    text-align: center;\n    text-decoration: none;\n    font-size: 15px;\n    width: 170px;\n    /* border-style: solid; */\n    border: 0px solid rgba(107, 92, 209, 1);\n    float: right;\n    margin-top: 60px\n}\n\n.generatetext {\n    margin-top: 10px;\n    font-size: 13px;\n    font-weight: 500;\n}\n\n.generatetextbelow {\n    margin-top: -19px;\n    font-size: 13px;\n    font-weight: 500;\n}\n\n.workorder-history-title {\n    font-size: 13px;\n    color: white;\n    margin-left: 20px;\n    font-weight: 500;\n}\n.workorder-planned-title {\n    font-size: 13px;\n    color: white;\n    margin-left: 20px;\n    font-weight: 500;\n    margin-top: 7px;\n}\n/* .workorder-planned {\n    height: 100px;\n    width: 1060px;\n    margin-left: 20px;\n    margin-right: 10px;\n    border: 1px solid #8d97dac5;\n    border-radius: 5px;\n    overflow: hidden;\n} */\n\n.workorder-hide-scroll {\n    overflow: auto;\n    /* width: 100%; */\n    padding-right: 17px;\n    box-sizing: content-box;\n    height: fit-content;\n    width: 1050px;\n    margin-left: 20px;\n    margin-right: 10px;\n    border: 1px solid #8d97dac5;\n    border-radius: 5px;\n}\n\n/* tbody::-webkit-scrollbar {\n    width: 1em;\n  } */\n\n/* tbody::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  }\n    */\n/* tbody::-webkit-scrollbar-thumb {\n    background-color: darkgrey;\n    outline: 1px solid slategrey;\n  } */\n/* Track */\n\n\n/* Handle on hover */\n/* ::-webkit-scrollbar-thumb:hover {\n    background: #b30000;\n} */\n\n/* .workorder-history {\n    overflow: hidden;\n    height: 200px;\n    width: 1060px;\n    margin-left: 20px;\n    margin-right: 10px;\n    border: 1px solid #8d97dac5;\n    border-radius: 5px;\n} */\n\n.workorder-history-table {\n    overflow: auto;\n    /* height: 100%;\n    width: 100%; */\n    margin-left: 15px;\n    margin-right: 10px;\n    height: 300px;\n    width: 1050px;\n    border: 1px solid #8d97dac5;\n    border-radius: 5px;\n    padding-right: 17px;\n    /* padding-bottom: 17px; */\n    box-sizing: content-box\n}\n\n.planned-table {\n    border: 1px solid #8d97dac5;\n    border-spacing: 100px;\n    table-layout: fixed;\n    /* width: 180px; */\n}\n\n.planned-table th {\n    border: 1px solid #8d97dac5;\n    padding: 5px;\n    background-color: rgba(116, 123, 169, 1);\n    color: white;\n    font-size: 13px;\n    font-weight: normal;\n    text-align: center;\n    position: sticky;\n    top: 0; \n    /* width: 1000px; */\n    /* white-space: nowrap; */\n}\n\n.planned-table td {\n    border: 1px solid #8d97da76;\n    padding: 1px;\n    color: white;\n    font-size: 12px;\n    text-align: center;\n    /* white-space: nowrap */\n    /* object-fit: cover; */\n}\n\n/* .tbody{\n    z-index: -9;\n    width: 500%;\n}\n.thead{\n    z-index: 100;\n    \n} */\n\n.info-icon {\n    margin-right: 20px;\n    /* width: 15%; */\n}\n\n.gts {\n    width: 98%;\n    /* height: 50%; */\n    background-color: #8d97dac5;\n    color: white;\n    border-radius: 5px;\n    margin-left: 10px;\n    /* display: inline-block; */\n    margin-top: 6px;\n\n}\n\n.generateTitle {\n    padding-top: 8px;\n    padding-bottom: 8px;\n    font-size: 14px;\n    font-family: Graphik;\n    text-align: center;\n}\n\n.closeicon {\n    width: 18px;\n    height: 18px;\n    float: right;\n    margin-top: 2px;\n    margin-right: 15px;\n}\n\n.generate-data {\n    color: white;\n    padding: 2px;\n    margin-top: 6px;\n    margin-left: 10px;\n    display: flex;\n    flex-direction: row;\n}\n\n.generatecol-one {\n    padding-right: 10px;\n}\n\n.container-row {\n    display: flex;\n    flex-direction: row;\n    font-size: 12px;\n    font-family: Graphik;\n    padding-top: 10px;\n}\n\n.container-label {\n    margin-left: 5px;\n}\n\n.container-data {\n    background-color: #25304C;\n    width: 200px;\n    height: 30px;\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 5px;\n    border-color: #8d97dac5;\n    text-align: left;\n    padding: 5px;\n    color: white\n}\n\n.generate-header {\n    color: white;\n    padding-top: 9px;\n    padding-bottom: 9px;\n    font-size: 13px;\n    font-family: Graphik;\n    font-weight: 500;\n}\n\n.loading {\n    color: white;\n}\n\n.loadingstyle {\n    color: white;\n    font-size: medium;\n    width: 85vw;\n    height: 70vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.insights {\n    overflow: hidden;\n    height: 550px;\n    color: white;\n    margin-top: 15px;\n    margin-left: 10px;\n    width: 1100px;\n}\n\n.hidescroll {\n    /* height: 500px; */\n    /* overflow-y: auto; */\n    width: 1150px;\n    height: 100%;\n    overflow-y: auto;\n    padding-right: 17px;\n    /* Increase/decrease this value for cross-browser compatibility */\n    box-sizing: content-box\n}\n\n.flexrow {\n    /* margin-left: 23px; */\n    margin-top: 5px;\n    color: white;\n    display: flex;\n    background-color: rgba(255, 255, 255, 0.05);\n    width: 1100px;\n    padding: 15px;\n    border-radius: 8px;\n    border-width: 1px;\n    border-style: solid;\n    border-color: rgba(116, 123, 169, 1);\n    height: 460px;\n}\n\n.flexrow1 {\n    /* margin-left: 23px; */\n    margin-top: 5px;\n    color: white;\n    display: flex;\n    background-color: rgba(255, 255, 255, 0.05);\n    width: 1100px;\n    padding: 15px;\n    border-radius: 8px;\n    border-width: 1px;\n    border-style: solid;\n    border-color: rgba(116, 123, 169, 1);\n    height: 320px;\n}\n\n.flexrow3 {\n    margin-left: 2px;\n    color: white;\n    display: flex;\n    /* background-color: rgba(255, 255, 255, 0.05); */\n    padding: 15px;\n    /* border-radius: 8px; */\n    border-width: 1px;\n    border-color: rgba(116, 123, 169, 1);\n    /* height: 320px; */\n    background-color: rgba(37, 42, 74, 1);\n    border-width: 1px;\n    border-bottom-style: solid;\n    /* border-color: rgba(65, 67, 82, 1); */\n    border-radius: 5px;\n    height: 30px;\n    color: white;\n    width: 1095px;\n    padding-top: 2px;\n}\n\n.chart {\n    margin-bottom: 15px;\n}\n.sop-box{\n    border-radius: 8px;\n    border-width: 1px;\n    border-style: solid;\n    border-color: rgba(116, 123, 169, 1);\n    background-color: rgba(255, 255, 255, 0.05);\n    width: 1100px;\n\n}\n\n/* .chartborder{\n    color: rgba(65, 67, 82, 1);\n} */\n.chartborderright {\n    /* margin-left: 13px; */\n    border-color: rgba(65, 67, 82, 1);\n    border-left-style: solid;\n    border-width: 1px;\n    padding-left: 30px;\n}\n.pdf-cd-box-rt{\n    margin-bottom: 15px;\n    margin-left: 5px;\n    display: flex;\n\n}\n.pdf-text{\n    margin-left: 30px;\n    font-size: 11px;\n    font-weight: 300;\n    font-family: Graphik;\n    color: white;\n    width:250px;\n    height: 60px;\n    padding: 10px;\n    text-align: left;\n}\n.pdf-cd-box{\n    margin-bottom: 15px;\n    margin-left: 5px;\n    display: flex;\n}\n.heading-chart {\n    font-size: 14px;\n    font-weight: 500;\n    font-family: Graphik;\n    color: white;\n    margin-left: 20px;\n}\n\n.heading-analysis {\n    font-size: 14px;\n    font-weight: 500;\n    font-family: Graphik;\n    color: white;\n    margin-left: 10px;\n}\n\n\n.pdf-heading {\n    font-size: 14px;\n    font-weight: 500;\n    font-family: Graphik;\n    color: white;\n    margin-left: 10px;\n    margin-top: 10px;\n}\n\n.chart-box {\n    margin-left: -10px;\n}\n\n.points {\n    font-size: 12px;\n    font-weight: 350;\n    font-family: Graphik;\n    color: rgb(199, 239, 246);\n}\n\n/* ul{ list-style: none;list-style-position: outside;\n } */\n/* ul li {\n    margin-bottom: -10px;\n    color: aliceblue;\n} */\n\n/* ul li:before{ content:\"•\"; font-size:10pt;}\n\nli:before{ margin-right: 10px;} */\n\n\n.xAxis .recharts-layer.recharts-cartesian-axis-tick text {\n    transform: translate(0, 2px);\n    font-family: Roboto, sans-serif;\n}\n\n.yAxis .recharts-layer.recharts-cartesian-axis-tick text {\n    transform: translate(-5px, 0);\n}\n\n.flexborder {\n    background-color: rgba(37, 42, 74, 1);\n    border-width: 1px;\n    border-style: solid;\n    border-color: rgba(65, 67, 82, 1);\n    border-radius: 5px;\n    height: 30px;\n    color: white;\n    display: flex;\n    width: 1100px;\n    padding-top: 2px;\n}\n\n.heading-topic {\n    font-size: 14px;\n    font-weight: 500;\n    font-family: Graphik;\n    color: white;\n    margin-left: 10px;\n    padding: 2px\n}\n\n.chart-box-below {\n    width: 500px;\n}\n\n.custom-legend {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n}\n\n.legend-item {\n    display: flex;\n    align-items: center;\n    margin-right: 20px;\n    margin-bottom: 10px;\n}\n\n.custom-legends {\n    display: flex;\n    align-items: center;\n    position: absolute;\n    bottom: 10px;\n    left: 50%;\n    transform: translateX(-76%) translateY(-30%);\n}\n.custom-legends-shape {\n    margin-right: 20px;\n    margin-bottom: 10px;\n    display: flex;\n    align-items: center;\n    position: absolute;\n    bottom: 10px;\n    left: 50%;\n    transform: translateX(-40%) translateY(120%);\n}\n\n\n.legend-items {\n    white-space: nowrap; \n    display: flex;\n    align-items: center;\n    /* margin-right: 10px; */\n    margin-left: 10px;\n}\n.custom-legends-shape2 {\n    margin-right: 10px;\n    margin-bottom: 10px;\n    display: flex;\n    align-items: center;\n    position: absolute;\n    bottom: 10px;\n    left: 50%;\n    transform: translateX(-42%) translateY(215%);\n}\n\n\n.legend-items2 {\n    white-space: nowrap; \n    display: flex;\n    align-items: center;\n    /* margin-right: 10px; */\n    margin-left: 10px;\n}\n\n.shape {\n    width: 8px;\n    height: 8px;\n    margin-right: 5px;\n}\n\n.shape-circle {\n    background-color: aliceblue;\n    border-radius: 50%;\n}\n\n.shape-square {\n    background-color: aliceblue;\n}\n\n.shape-triangle {\n    border-left: 5px solid transparent;\n    border-right:5px solid transparent;\n    border-bottom: 10px solid aliceblue;\n}\n\n.shape-cross {\n    background: aliceblue;\n      height: 10px;\n      position: relative;\n      width: 2px;\n      right:4px;\n}\n.shape-cross:after {\n    background: aliceblue;\n    content: \"\";\n    height: 2px;\n    left: -4px;\n    position: absolute;\n    top: 4px;\n    width: 10px;\n\n}\n.shape-diamond {\n    width: 0;\n    height: 0;\n    border: 5px solid transparent;\n    border-bottom: 7px solid aliceblue;\n    position: relative;\n    top: -5px;\n  }\n.shape-diamond:after {\n    content: '';\n    position: absolute;\n    left: -4.2px;\n    top: 6px;\n    width: 0;\n    height: 0;\n    border: 5px solid transparent;\n    border-top: 7px solid aliceblue;\n  }\n\n.chatboticon {\n    float: right;\n    cursor: pointer;\n}\n\n/* .infoicon{\n    margin-left: 560px;\n    width: 30px;\n} */\n\n.top-sum {\n    padding-right: 5px;\n}\n\n.tab {\n    margin-right: 10px;\n}\n\n.pdf-cd{\n    width:50px;\n    height:70px;\n    margin-left: 10px;\n}\n.pdf-contanier{\n    margin: 15px;\n    padding: 5px;\n    background-color: rgba(255, 255, 255, 0.05);\n    width: 1100px;\n    border-radius: 8px;\n    border-width: 1px;\n    border-style: solid;\n    border-color: rgba(116, 123, 169, 1);\n    height: 460px;\n}\n\n.close-pdf{\n    height: 30px;\n    margin-top: 10px;\n    margin-right: 5px;\n    cursor: pointer;\n}\n\n.q-model{\n    background-color: rgba(30, 32, 61, 1);\n    border-radius: 10px;\n    border: 1px solid rgba(107, 92, 209, 1);\n    height:400px;\n    width: 100px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: fixed;\n    z-index: 1000;\n    padding-top: 10px;\n    top: 0;\n    left: 0;\n    width:100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
